import { Link } from "@tanstack/react-router";
import { Facebook, Instagram } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border bg-card/30 px-4 py-12">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col items-center gap-8 md:flex-row md:justify-between">
          {/* Branding */}
          <div className="text-center md:text-left">
            <span className="font-display text-xl font-bold uppercase tracking-wider text-foreground">
              SZESE <span className="text-primary">Setup</span>{" "}
              <span className="text-accent">Shop</span>
            </span>
            <p className="mt-1 text-xs text-muted-foreground">
              Powered by Sz&eacute;chenyi Istv&aacute;n University
            </p>
          </div>

          {/* Links */}
          <nav className="flex items-center gap-6 text-sm text-muted-foreground">
            <Link to="/legal/privacy" className="transition-colors hover:text-foreground">
              Privacy
            </Link>
            <Link to="/legal/terms" className="transition-colors hover:text-foreground">
              Terms
            </Link>
            <a
              href="https://www.instagram.com/szeseesport/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:text-foreground"
              aria-label="Instagram"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href="https://www.facebook.com/esportszese/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:text-foreground"
              aria-label="Facebook"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </nav>
        </div>

        <div className="mt-8 text-center text-xs text-muted-foreground/50">
          &copy; {new Date().getFullYear()} SZESE E-Sport. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
